import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { usePositioningStyles } from './PositioningSection.styles';
import { fadeUp, viewportOnce } from '../../../../styles/animations';

const PositioningSection = () => {
    const { classes } = usePositioningStyles();

    return (
        <Box component="section" className={classes.section}>
            <Box className={classes.inner}>
                <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={fadeUp}>
                    <Typography variant="display2" component="p" className={classes.statement}>
                        Complex problems.<br />Clear solutions.
                    </Typography>
                </motion.div>
            </Box>
        </Box>
    );
};

export default PositioningSection;
